import { Navigate } from "react-router-dom";

import { auth } from "../firebase";

import { useAuthState } from "react-firebase-hooks/auth";



function ProtectedRoute({children}){


const [user,loading]=useAuthState(auth);



if(loading){

return <h2>Loading...</h2>;

}



if(!user){

return <Navigate to="/admin-login"/>

}



return children;


}


export default ProtectedRoute;